import { render } from "./LicenceAcceptanceScreen.vue?vue&type=template&id=166930d2&scoped=true"
import script from "./LicenceAcceptanceScreen.vue?vue&type=script&lang=js"
export * from "./LicenceAcceptanceScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=166930d2&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.8\\installer\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166930d2"]])

export default __exports__